import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
// import { submitContactUsForm, SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService"; // Store Custom Code

/* Store Custom Code - Start */
import { SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";
import { submitContactUsForm } from "@store/Framework/Services/EmailService";
/* Store Custom Code - End */

type SubmitContactFormParameter = {
    emailRecipients: string;
    formTitle: string;
    customFieldsOrder?: string[];
} & HasOnSuccess;

/* Store Custom Code - Start */
interface StoreSubmitContactUsFormApiParameter extends SubmitContactUsFormApiParameter {
    formTitle: string;
    customFields?: { [key: string]: string };
    customFieldsOrder?: string[];
}

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, StoreSubmitContactUsFormApiParameter>;
/* Store Custom Code - End */

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState().components.contactUsForm;
    props.apiParameter = {
        topic: state.fieldValues["topic"],
        firstName: state.fieldValues["firstName"],
        lastName: state.fieldValues["lastName"],
        phoneNumber: state.fieldValues["phoneNumber"],
        emailAddress: state.fieldValues["emailAddress"],
        message: state.fieldValues["message"],
        emailTo: props.parameter.emailRecipients,
        // Store Custom Code
        formTitle: props.parameter.formTitle,
        customFieldsOrder: props.parameter.customFieldsOrder || [],
    };
};

/* Store Custom Code - Start */
export const PopulateCustomFieldsParameter: HandlerType = props => {
    const state = props.getState().components.contactUsForm;
    const defaultParams = Object.keys(props.apiParameter);
    const customKeys = Object.keys(state.fieldValues).filter(key => !defaultParams.includes(key));
    const customFields: { [key: string]: string } = {};

    customKeys.forEach(key => {
        const value = state.fieldValues[key];
        if (typeof value === "string") {
            customFields[key] = value;
        }
    });

    props.apiParameter = {
        ...props.apiParameter,
        customFields,
    };
};
/* Store Custom Code - End */

export const SendDataToApi: HandlerType = async props => {
    await submitContactUsForm(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [
    PopulateApiParameter,
    PopulateCustomFieldsParameter, // Store Custom Code
    SendDataToApi,
    ExecuteOnSuccessCallback,
];

const submitContactForm = createHandlerChainRunner(chain, "SubmitContactForm");
export default submitContactForm;
